<template>
  <az-formbar>
    <div class="show header-pregao">
      <div class="itens">
        <div class="item pl-2">
          <label>Processo</label>
          <span>{{ compraDireta.processo || '-' }}</span>
          <br>
          <span v-if="compraDireta.numRepeticao > 0">
            <strong>Repetição:</strong> {{ compraDireta.numRepeticao || '-' }}
          </span>
        </div>
        <div class="item">
          <label>Situação</label>
          <span>{{ compraDireta.situacao | azEnum(situacoesCompraDireta) }}</span>
        </div>
      </div>

      <div class="actions">
        <div class="acessar-wrapper">
          <az-call-to-action dark :active="true" :outline="true"
                             @click="handleAcessarClick" class="no-mobile">
            ACESSAR
          </az-call-to-action>

          <div v-if="showOptions" class="dropdown-options">
            <button @click="acessarComo('Fornecedor')">Fornecedor</button>
            <button @click="acessarComo('Comprador')">Comprador</button>
          </div>
        </div>
      </div>
    </div>
  </az-formbar>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesCompraDireta} from '@/core/constants'

export default {
    name: 'CompraDiretaVisualizacaoAcoes',
    data() {
        return {
            showOptions: false
        }
    },
    computed: {
        ...mapState(['compraDireta']),
        situacoesCompraDireta() {
            return situacoesCompraDireta
        }
    },
    methods: {
        handleAcessarClick() {
            this.showOptions = !this.showOptions
        },
        acessarComo(tipo) {
            const compraDiretaId = this.compraDireta.id
            let urlPath = ''

            if (tipo === 'Comprador') {
                urlPath = `compra-direta/#/comprador/execucao/${compraDiretaId}/dadosGerais/visualizacao`
            } else if (tipo === 'Fornecedor') {
                urlPath = `compra-direta/#/fornecedor/detalhes/${compraDiretaId}`
            }

            const url = `${window.location.protocol}//${window.location.host}/${urlPath}`
            window.open(url, '_blank')
            this.showOptions = false
        }
    }
}
</script>

<style scoped>
.header-pregao { padding: 5px; }
.header-pregao .az-form-bar { border-top-left-radius: 5px !important; border-top-right-radius: 5px !important; }
.item { display: flex; margin-right: 25px !important; }
.item label { font-weight: bold; }
.item-right { color: white; display: flex; flex-direction: column; }
.item-right label { font-size: 12px; font-weight: bold; }
.item-right .btn-cancelar-envio-proposta { display: flex !important; flex-direction: column; justify-content: center; margin-right: 0 !important; }
.actions .acessar-wrapper { position: relative; }
.actions .acessar-wrapper .dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  z-index: 1000;
}
.actions .acessar-wrapper .dropdown-options button { background: none; border: none; padding: 5px 15px; text-align: left; cursor: pointer; }
.actions .acessar-wrapper .dropdown-options button:hover { background: #f0f0f0; }
.az-form-bar .show { min-height: 70px !important; height: auto !important; }
</style>
